/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/28/2023
 */

import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../../base/services/ResApi";
import { FormControl } from "@mui/material";

const OrgsDropdown = ({
  orgCode,
  onChange,
  isRequired,
  isOrgDisabled,
  selectRef,
}) => {
  const [data, setData] = useState([])

  let apprvConfig = {
    headers: {
      Action: "V_APPR_ORG",
      "Page-Number": 1,
      "Page-Size": 500,
      "Sort-Column": "org_code",
      "Sort-Order": "asc",
    },
  }

  useEffect(() => {
    const fetchData = () => {
      api
        .get("/organizations", apprvConfig)
        .then((res) => {
          setData(res.data?.dataList)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    fetchData()
  }, [])

  // Selector
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "10px",
    }),
  }

  const options = data.map((item) => ({
    value: item.orgCode,
    label: item.orgName,
    target: { name: "orgCode", value: item.orgCode },
  }))

  return (
    <div>
      <p
        style={{
          fontSize: "12px",
          position: "relative",
          top: "-9px",
          left: "10px",
          background: "#fff",
          width: "130px",
          paddingLeft: "5px",
          zIndex: 99,
        }}
      >
        Select Organization
      </p>
      <FormControl
        required={isRequired}
        sx={{
          minWidth: 400,
          zIndex: 90,
          position: "relative",
          top: "-32px",
          height: 0,
        }}
        size="medium"
      >
        <Select
          ref={selectRef}
          options={options}
          value={options.find((option) => option.value === orgCode)}
          onChange={onChange}
          isDisabled={isOrgDisabled}
          isClearable
          styles={{
            ...customStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // Ensure it appears above other elements
            }),
          }}
          menuPortalTarget={document.body} 
          menuPosition="fixed" 
        />
      </FormControl>
    </div>
  )
}

export default OrgsDropdown;
